/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSideProps } from 'next'
import { ROUTES, ROUTER_PATH } from '@/client/utils/index'

/**
 *
 * @param staticPageSlugs - Wordpress Slugs
 * @returns CMS API Response
 */
const fetchFromCMS = async (staticPageSlugs) => {
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS || ''
  const defaultLocale = process.env.NEXT_DEFAULT_LOCALE || 'en'
  const perPage = 20

  let allData: any[] = []
  const firstResponse = await fetch(
    `${CMSApi}/${staticPageSlugs}acf_format=standard&lang=${defaultLocale}` +
      `&_fields=id,slug,modified_gmt&per_page=${perPage}&page=1&status=publish&_=${Date.now()}`,
    {
      next: { revalidate: 3600 }
    }
  )

  const totalPages = Number(firstResponse.headers.get('X-WP-TotalPages')) || 1
  const totalItems = Number(firstResponse.headers.get('X-WP-Total')) || 0

  const firstData = await firstResponse.json()
  allData = firstData

  if (totalPages === 1) {
    return { data: allData, totalPages, totalItems }
  }

  const requests: Promise<any>[] = []

  for (let page = 2; page <= totalPages; page++) {
    requests.push(
      fetch(
        `${CMSApi}/${staticPageSlugs}acf_format=standard&lang=${defaultLocale}` +
          `&_fields=id,slug,modified_gmt&per_page=${perPage}&page=${page}&status=publish&_=${Date.now()}`,
        {
          next: { revalidate: 3600 }
        }
      ).then((res) => res.json())
    )
  }

  const results = await Promise.all(requests)

  results.forEach((data) => {
    allData = allData.concat(data)
  })

  return {
    data: allData,
    totalPages,
    totalItems
  }
}

export const excludedSlugs = new Set([
  'home',
  'inizio',
  'carrello',
  'cart',
  'cesta',
  'panier',
  'calcolatore',
  'calculator',
  'calculadora',
  'calculateur',
  'inicio',
  'accueil',
  'forgot-password',
  'se-te-olvido-tu-contrasena',
  'password-dimenticata',
  'wachtwoord-reset',
  'reinitialiser-mot-de-passe',
  'page-not-found',
  'pagina-no-encontrada',
  'pagina-non-trovata',
  'pagina-niet-gevonden',
  'page-introuvable',
  'upload-files',
  '404',
  'calculator-help',
  'header',
  'footer',
  'pagina',
  'page',
  'mi-cuenta',
  'mi-cuenta/ordenes',
  'mi-cuenta/servicios-de-revision',
  'mi-cuenta/servicios-de-diseno',
  'mi-cuenta/informacion-personal',
  'mi-cuenta/biblioteca-de-etiquetas',
  'mi-cuenta/biblioteca-de-etiquetas/myorder-files',
  'mi-cuenta/biblioteca-de-etiquetas/custom-files',
  'my-account',
  'il-mio-account',
  'my-account/personal-infos',
  'my-account/artwork-services',
  'my-account/design-services',
  'my-account/label-library',
  'my-account/label-library/reorder',
  'my-account/label-library/myorder-files',
  'my-account/label-library/custom-files',
  'mi-cuenta/informazioni-personali',
  'password-dimenticata',
  'my-account/orders',
  'il-mio-account/ordini',
  'mon-compte',
  'mon-compte/mes-commandes',
  'mon-compte/correction-graphique',
  'mon-compte/creation-graphique',
  'mon-compte/factures',
  'mon-compte/personal-infos',
  'mon-compte/bibliotheque-etiquettes/reorder',
  'mon-compte/bibliotheque-etiquettes/myorder-files',
  'mon-compte/bibliotheque-etiquettes/custom-files',
  'pagina-de-errores',
  'error-page',
  'pagina-di-errore',
  'foutpagina',
  'page-erreur',
  'mijn-account/mijn-orders',
  'mi-cuenta/facturas',
  'my-account/invoices',
  'mijn-account/facturen',
  'mijn-account',
  'mijn-account/drukbestandenservice',
  'mijn-account/persoonlijke-gegevens',
  'mijn-account/labelbibliotheek',
  'mijn-account/labelbibliotheek/myorder-files',
  'mijn-account/labelbibliotheek/reorder',
  'mijn-account/labelbibliotheek/custom-files',
  'blogs-landing-page',
  'world-of',
  'pre-print-artwork',
  'il-mio-account',
  'il-mio-account/fatture',
  'il-mio-account/servizio-di-correzione',
  'il-mio-account/servizio-di-correzione-file-in-corso',
  'il-mio-account/servizio-di-correzione-file',
  'il-mio-account/servizio-di-progettazione-grafica',
  'il-mio-account/informazioni-personali',
  'il-mio-account/libreria-etichette',
  'il-mio-account/libreria-etichette/reorder',
  'il-mio-account/libreria-etichette/myorder-files',
  'il-mio-account/libreria-etichette/custom-files',
  'administrar-credenciales',
  'manage-credentials',
  'administrar-credenciales',
  'beheer-inloggegevens',
  'libreria-delle-etichette',
  'label-library',
  'libreria-etichette',
  'bibliotheque-etiquettes',
  'terms-and-conditions-of-use',
  'il-mondo-di',
  'terms-and-conditions',
  'gracias-por-suscribirte',
  'gracias-por-tu-pedido',
  'gracias-por-tu-solicitud',
  'gracias-por-participar-en-nuestra-encuesta',
  'thank-you-for-participating-in-survey',
  'participation-enquete',
  'thank-you',
  'thank-you-for-your-order',
  'thank-you-for-your-request',
  'sondaggio-completato',
  'grazie-per-la-tua-richiesta',
  'nieuwsbrief-abonnement',
  'grazie-per-il-tuo-ordine',
  'grazie-per-liscrizione',
  'abonnement-newsletter-reussi',
  'dank-voor-uw-bestelling',
  'merci-pour-votre-commande',
  'dank-materialenboek',
  'merci-book-echantillons',
  'enquete-ingevuld',
  'succesvol-geregistreerd',
  'activate-account',
  'attivazione-account',
  'signup-success',
  'creation-compte-reussie',
  'winkelwagen',
  'bienvenido',
  'bienvenu',
  'welcome',
  'welkom',
  'benvenuto',
  'mi-cuenta/biblioteca-de-etiquetas/reorder',
  'reorder',
  'myorder-files',
  'assistant-de-creation-graphique',
  'template-etichette',
  'crea-un-account',
  'creer-compte-client',
  'inscribirse',
  'signup',
  'account-aanmaken',
  'creer-compte-client',
  'recensione-del-servizio-di-grafica',
  'artwork-service-revision',
  'revision-correction-graphique',
  'validation-bat',
  'accesso',
  'login',
  'acceso',
  'newsletter-subscription-successful',
  'order-thank-you',
  'sample-book-thank-you',
  'survey-taken'
])

let cachedSitemap: string | null = null
let cachedTime = 0

const CACHE_DURATION = 1000 * 60 * 60 * 24 // 24 hours Best for sites that publish a few times a week or less

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  const now = Date.now()

  // RETURN CACHE IF VALID
  if (cachedSitemap && now - cachedTime < CACHE_DURATION) {
    res.setHeader('Content-Type', 'text/xml')
    res.write(cachedSitemap)
    res.end()

    return { props: {} }
  }

  // const baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL || process.env.DOMAIN_URL
  const CMSApi = process.env.NEXT_PUBLIC_API_CMS || ''
  const defaultLocale = process.env.NEXT_DEFAULT_LOCALE || 'en'
  let baseUrl = ''
  // Contains Route path and wordpress slug of all pages in the app.
  let staticPageRowData: { url: string; slug: string }[] = []
  // staticPageRowData will be updated with modified_gmt

  switch (true) {
    case CMSApi.includes('https://it.cms.etikett.de/'):
      baseUrl = 'https://etichetta.it'
      break
    case CMSApi.includes('https://es.cms.etikett.dev/'):
      baseUrl = 'https://shop.etikett.dev'
      break
    case CMSApi.includes('https://es.cms.etikett.de/'):
      baseUrl = 'https://etiqueta.es'
      break
    case CMSApi.includes('https://nl.cms.etikett.de/'):
      baseUrl = 'https://unieketiket.nl'
      break
    case CMSApi.includes('https://fr.cms.etikett.de/'):
      baseUrl = 'https://labelletiquette.fr'
      break
    case CMSApi.includes('https://label.cms.etikett.de/'):
      baseUrl = 'https://label.co.uk'
      break
    default:
      baseUrl = process.env.NEXT_PUBLIC_DOMAIN_URL || process.env.DOMAIN_URL || ''
  }

  Object.entries(ROUTES).forEach(([routeKey, routeValue]) => {
    const routePath = ROUTER_PATH[routeKey]
    staticPageRowData.push({ url: routePath[`${defaultLocale}`], slug: routeValue[`${defaultLocale}`] })
  })

  staticPageRowData = staticPageRowData.reduce((acc: { url: string; slug: string }[], current) => {
    if (!acc.some((item) => item.url === current.url)) {
      acc.push(current)
    }
    return acc
  }, [])

  const [
    staticPageCmsResponse,
    productsCmsResponse,
    blogCmsResponse,
    customPageCmsResponse,
    tutorialPageCmsResponse,
    printFileErrorPageCmsResponse,
    successStoriesPageCmsResponse
  ] = await Promise.all([
    await fetchFromCMS(`pages?`), // Includes all static pages like About-us, news, homepage, privacy-policy, etc...
    fetchFromCMS(`${ROUTES['PRODUCTS']['en']}?`), // English slug is using in wordpress
    fetchFromCMS(`blog?`),
    fetchFromCMS(`custom-page?`),
    fetchFromCMS(`tutorial?`),
    fetchFromCMS(`${ROUTES['PRINT_FILE_ERRORS'][defaultLocale]}?`),
    fetchFromCMS(`${ROUTES['SUCCESS_STORIES'][defaultLocale]}?`)
  ])

  // console.log(staticPageRowData, 'staticPageRowData')
  staticPageRowData = staticPageCmsResponse.data.map((e) => {
    // const matchedSlugs: any = staticPageRowData.find((se) => se['slug'] === e['slug'])
    const matchedSlugs: any = staticPageRowData.find((se) => se['slug'] === e['slug'])

    return (
      (e['slug'] === 'blogs-landing-page' && {
        url: '/blog',
        slug: 'blogs-landing-page',
        modified_gmt: e['modified_gmt']
      }) ||
      (['historias-de-exito', 'temoignages', 'success-stories', 'storie-di-successo'].includes(e['slug']) && {
        url: ROUTER_PATH['SUCCESS_STORIES'][defaultLocale],
        slug: ROUTES['SUCCESS_STORIES'][defaultLocale],
        modified_gmt: e['modified_gmt']
      }) ||
      (['categorias', 'categories', 'categories', 'products', 'categorie', 'producten', 'produits'].includes(
        e['slug']
      ) && {
        url: ROUTER_PATH['PRODUCTS'][defaultLocale],
        slug: ROUTES['PRODUCTS'][defaultLocale],
        modified_gmt: e['modified_gmt']
      }) ||
      ([
        'print-file-error',
        'fichiers-non-conformes',
        'data-errors-in-your-print-files',
        'errors-in-druckbestanden',
        'errori-comuni-nei-file-di-stampa'
      ].includes(e['slug']) && {
        url: ROUTER_PATH['PRINT_FILE_ERRORS_FULL'][defaultLocale],
        slug: ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale],
        modified_gmt: e['modified_gmt']
      }) || { ...matchedSlugs, modified_gmt: e['modified_gmt'] } // 👉 default fallback (your original logic)
    )
  })

  // Final Static page URLs are stored here.
  const staticRoutesURLs = staticPageRowData
    .filter((e) => e?.url)
    .filter((e) => !excludedSlugs.has(e.slug))
    .filter((e) => e?.url !== '/')
    .map((e: any) => `${baseUrl}${e.url}/?time=${e.modified_gmt}`)
  // End - Static Pages
  // **************************************
  // **************************************
  // Start - Products pages
  // A new logic is yet to deploy for dynamic imports
  // **************************************
  // **************************************

  const productSlugs: string[] = []
  const customPagesSlugs: string[] = []
  const blogPagesSlugs: string[] = []
  const tutorialsSlug: string[] = []
  const printFileSlug: string[] = []
  const successStorySlug: string[] = []
  const productPagesFormatted: string[] = []
  const customPagesFormatted: string[] = []
  const blogsFormatted: string[] = []
  const tutorialFormatted: string[] = []
  const printFileErrorFormatted: string[] = []
  const successStoriesFormatted: string[] = []

  // const productPages = await Promise.all(locales?.map(() => fetchJson(`${CMSApi}/products?per_page=100&page=1`)) || [])
  const productPages: any = productsCmsResponse.data
  const customPages: any = customPageCmsResponse.data
  const blogspageData: any = blogCmsResponse.data
  const tutorialPageData: any = tutorialPageCmsResponse.data
  const printFileErrorPageData: any = printFileErrorPageCmsResponse.data
  const successStoryPageData: any = successStoriesPageCmsResponse.data

  // ************
  // productPages[0].map((page) => productSlugs.push(page.slug))
  productPages.map((page) => productSlugs.push(page))
  customPages.map((page) => customPagesSlugs.push(page))
  blogspageData.map((page) => blogPagesSlugs.push(page))
  tutorialPageData.map((page) => tutorialsSlug.push(page))
  printFileErrorPageData.map((page) => printFileSlug.push(page))
  successStoryPageData.map((page) => successStorySlug.push(page))
  productSlugs.forEach((page: any) => {
    // checks the locale.
    const localePrefix = `/`
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = 'products'
        break
      case 'es':
        routeName = 'productos'
        break
      case 'it':
        routeName = 'prodotti'
        break
      case 'nl':
        routeName = 'producten'
        break
      case 'fr':
        routeName = 'produits'
        break
      case 'uk':
        routeName = 'products'
        break
      default:
        routeName = ROUTES['PRODUCTS'][defaultLocale || 'en']
    }

    productPagesFormatted.push(`${baseUrl}${localePrefix}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })

  customPagesSlugs.forEach((page: any) => {
    // checks the locale.
    const localePrefix = `/`
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = 'page'
        break
      case 'es':
        routeName = 'pagina'
        break
      case 'it':
        routeName = 'pagina'
        break
      case 'nl':
        routeName = 'pagina'
      case 'fr':
        routeName = 'page'
        break
      case 'uk':
        routeName = 'page'
        break
      default:
        routeName = ROUTES['CUSTOM_PAGES'][defaultLocale || 'en']
    }
    customPagesFormatted.push(`${baseUrl}${localePrefix}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })
  blogPagesSlugs.forEach((page: any) => {
    // checks the locale.
    const localePrefix = `/`
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = 'blog'
        break
      case 'es':
        routeName = 'blog'
        break
      case 'it':
        routeName = 'blog'
        break
      case 'nl':
        routeName = 'blog'
        break
      case 'fr':
        routeName = 'blog'
        break
      default:
        routeName = ROUTES['BLOGS'][defaultLocale || 'en']
    }

    blogsFormatted.push(`${baseUrl}${localePrefix}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })
  tutorialsSlug.forEach((page: any) => {
    // checks the locale.
    const localePrefix = `/`
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = ROUTES['TUTORIAL'][defaultLocale || 'en']
        break
      case 'es':
        routeName = 'tutoriales'
        break
      case 'it':
        routeName = ROUTES['TUTORIAL'][defaultLocale || 'en']
        break
      case 'nl':
        routeName = 'tutorials'
        break
      case 'fr':
        routeName = 'tutorials' // Needs change.
        break
      case 'uk':
        routeName = 'tutorials'
        break
      default:
        routeName = ROUTES['TUTORIAL'][defaultLocale || 'en']
    }

    tutorialFormatted.push(`${baseUrl}${localePrefix}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })

  printFileSlug.forEach((page: any) => {
    // checks the locale.
    const localePrefix = `/`
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
        break
      case 'es':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
        break
      case 'it':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
        break
      case 'nl':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
        break
      case 'fr':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en'] // Needs change.
        break
      case 'uk':
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
        break
      default:
        routeName = ROUTES['PRINT_FILE_ERRORS_FULL'][defaultLocale || 'en']
    }

    printFileErrorFormatted.push(`${baseUrl}${localePrefix}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })
  successStorySlug.forEach((page: any) => {
    // checks the locale.
    let routeName
    switch (defaultLocale) {
      case 'au':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      case 'es':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      case 'it':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      case 'nl':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      case 'fr':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      case 'uk':
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
        break
      default:
        routeName = ROUTER_PATH['SUCCESS_STORIES'][defaultLocale || 'en']
    }

    successStoriesFormatted.push(`${baseUrl}${routeName}/${page.slug}/?time=${page.modified_gmt}`)
  })

  // End - Product pages
  const sitemapsUrls = [
    `${baseUrl}/`,
    ...staticRoutesURLs,
    ...productPagesFormatted,
    ...blogsFormatted,
    ...customPagesFormatted,
    ...tutorialFormatted,
    ...printFileErrorFormatted,
    ...successStoriesFormatted
  ]

  /**
   * Find modified_gmt and update it as lastmod for sitemap.xml
   * @param url
   * @returns lastmod on ISOString();
   */
  const getLastmod = (url) => {
    const params = url.split('?time=')
    const time = params[1]
    return time ? new Date(time + 'Z').toISOString() : new Date().toISOString()
  }

  // Generate sitemap
  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
      ${sitemapsUrls
        .map((url) => {
          const path = url.replace('index', '')
          return `
            <url>
              <loc>${`${path.split('?')[0]}`}</loc>
              <lastmod>
  ${getLastmod(url)}
</lastmod>
              <changefreq>monthly</changefreq>
              <priority>1.0</priority>
            </url>
          `
        })
        .join('')}
    </urlset>
  `

  res.setHeader('Content-Type', 'text/xml')
  res.write(sitemap)
  res.end()

  cachedSitemap = sitemap
  cachedTime = Date.now()

  return {
    props: {}
  }
}

export default function Site() {}
// function swtich(NEXT_PUBLIC_DOMAIN_URL: string | undefined) {
//   throw new Error('Function not implemented.')
// }
